import React from "react";
import { Shippings } from "./shipping/Shippings";
import { Products } from "./Products";
import { CreditState } from "../../stores/credit/credit-state.interface";
import { useCreditDispatch } from "../../stores/credit/credit.store";
import { createOrderThunk } from "../../stores/credit/thunks/create-order.thunk";
import { OrderSection } from "./OrderSection";
import { Contact } from "./Contact";
import { useCreditSelector } from "../../stores/product/product.store";

export const Third = () => {
    const products = useCreditSelector((state: CreditState) => state.products);
    const text = useCreditSelector((state: CreditState) => state.text);
    const dispatch = useCreditDispatch();

    const next = () => {
        dispatch(createOrderThunk());
    }

    return (
        <>
            <div className="mb-4 rounded-2xl bg-white p-5">
                <Products products={ products }/>
            </div>
            <div className="rounded-2xl bg-white p-4 mb-4">
                <p className="text-lg font-semibold mb-4">{ text.shipping }</p>
                <Shippings />
            </div>
            {/* <Contact /> */}
            <OrderSection onSubmit={ next } />
        </>
    )
}